import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNorthStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 1.25C12.5 0.835786 12.1642 0.5 11.75 0.5C11.3358 0.5 11 0.835786 11 1.25V9.93931L6.44671 5.38603C6.15382 5.09313 5.67894 5.09313 5.38605 5.38603C5.09316 5.67892 5.09316 6.15379 5.38605 6.44669L9.93937 11H1.25C0.835787 11 0.5 11.3358 0.5 11.75C0.5 12.1642 0.835787 12.5 1.25 12.5H9.93936L5.38606 17.0533C5.09316 17.3462 5.09316 17.8211 5.38606 18.114C5.67895 18.4069 6.15382 18.4069 6.44672 18.114L11 13.5607V22.25C11 22.6642 11.3358 23 11.75 23C12.1642 23 12.5 22.6642 12.5 22.25V13.5606L17.0533 18.1139C17.3462 18.4068 17.8211 18.4068 18.114 18.1139C18.4069 17.8211 18.4069 17.3462 18.114 17.0533L13.5607 12.5H22.25C22.6642 12.5 23 12.1642 23 11.75C23 11.3358 22.6642 11 22.25 11H13.5607L18.114 6.4467C18.4069 6.15381 18.4069 5.67894 18.114 5.38604C17.8211 5.09315 17.3462 5.09315 17.0533 5.38604L12.5 9.93936V1.25Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgNorthStar;
